<div class="row mb-2" *ngIf="allowSearch">
    <div class="ml-auto col-auto pr-4">
        <mon-table-search
                [minSearchLength]="1"
                (getPage)="onSearchChanged($event)"
                [model]="search">
        </mon-table-search>
    </div>
</div>
<div class="form-group row mx-auto w-100"
     *ngFor="let model of models | slice: (page-1) * pageSize : page * pageSize; let indexPosition = index;">
    <label *ngIf="label"
           [attr.for]="labelText + indexPosition"
           class="col-sm-8 text-bold text-right capitalize-first-letter pt-1">
        {{ label }}
    </label>
    <div class="px-1" [ngClass]="{'col-sm-36' : label, 'col-sm-44': !label }">
        <div class="mon-dynamic-form-field-wrapper">
            <mon-form-field-input
                    (ngModelChange)="inputChangeRegisterBeforeModelChange(indexPosition, $event, model[attrName])"
                    [(ngModel)]="model[attrName]"
                    [type]="type"
                    [name]="labelText + indexPosition"
                    [id]="labelText + indexPosition"
                    [monPlaceholder]="placeholder">
            </mon-form-field-input>
            <ng-container *ngIf="rightItemLabelsPerPage && rightItemLabelsPerPage[indexPosition]">
                <div class="mon-dynamic-label-wrapper">
                    <span
                            [ngbTooltip]="rightItemLabelsPerPage[indexPosition]?.tooltipText || monRightItemLabelsTooltip"
                            [attr.class]="rightItemLabelsPerPage[indexPosition]?.class || monRightItemLabelsClass">
                        {{ rightItemLabelsPerPage[indexPosition]?.name || '' }}
                    </span>
                    <button
                            type="button"
                            (click)="onMonLabelDeleteButtonClick(indexPosition)"
                            [attr.aria-label]="monLabelDeleteButtonLabel"
                            [attr.class]="monLabelDeleteButtonClass"
                    >x</button>
                </div>
            </ng-container>
        </div>
        <span class="help-block">{{ helpText }}</span>
    </div>
    <div class="col-sm-4 text-right pr-1">
        <button type="button"
                (click)="removeFromModel(model)"
                [attr.aria-label]="'Remove ' + label"
                class="btn btn-default btn-secondary">
            <mon-icon monIconDirect="faTrashAlt"></mon-icon>
        </button>
    </div>
</div>
<div class="row">
    <div class="offset-sm-8 col-sm-40 d-flex align-items-center pr-5">
        <div class="mr-auto">
            <button type="button"
                    [attr.aria-label]="textInAddBtn ? null : 'Add ' + label"
                    (click)="pushToModel()"
                    class="btn btn-default btn-secondary">
                <mon-icon monIconDirect="faPlus"></mon-icon>
                {{textInAddBtn}}
            </button>
        </div>
        <div class="pr-2" *ngIf="allowPagination && models.length > 5">
            <ngb-pagination
                    [(page)]="page"
                    (pageChange)="onPageParamsChange()"
                    [maxSize]="7"
                    [pageSize]="pageSize"
                    [collectionSize]="models.length"
                    [rotate]="true">
                <ng-template ngbPaginationPrevious>&laquo;</ng-template>
                <ng-template ngbPaginationNext>&raquo;</ng-template>
            </ngb-pagination>
        </div>
    </div>
</div>
